import { useMemo } from "react";
import "./MindMappingReportBTenthSection.css";

/* ── Sector-specific market data (India, 2024-25 estimates) ───── */
const SECTOR_MARKET_DB = {
  /* Tertiary / Services */
  "SaaS":              { tam:"₹4,20,000 Cr", sam:"₹42,000 Cr", som:"₹840 Cr", cagr:"24% CAGR",  customer:"SMEs, enterprises, startups",       revenue:"Monthly / annual subscription",       entry:"₹30L–₹3 Cr seed",     driver:"Cloud adoption, SaaS-first India, remote work normalisation" },
  "EdTech":            { tam:"₹1,60,000 Cr", sam:"₹48,000 Cr", som:"₹4,800 Cr",cagr:"18% CAGR", customer:"Students K-12 to college, working professionals",revenue:"Subscription, pay-per-course",    entry:"₹25L–₹2 Cr seed",     driver:"NEP 2020, upskilling demand, smartphone penetration" },
  "FinTech":           { tam:"₹9,00,000 Cr", sam:"₹1,80,000 Cr",som:"₹5,400 Cr",cagr:"22% CAGR",customer:"MSMEs, retail consumers, rural segments",revenue:"Transaction fee, lending spread, SaaS",entry:"₹50L–₹5 Cr seed",     driver:"UPI ecosystem, financial inclusion mandate, MSME credit gap" },
  "HealthTech":        { tam:"₹2,20,000 Cr", sam:"₹66,000 Cr", som:"₹1,320 Cr",cagr:"21% CAGR", customer:"Urban consumers, hospitals, corporates",    revenue:"B2B SaaS, consultation fee, D2C",  entry:"₹50L–₹5 Cr seed",     driver:"ABDM, tele-medicine acceptance, preventive health trend" },
  "AgriTech":          { tam:"₹1,40,000 Cr", sam:"₹28,000 Cr", som:"₹700 Cr",  cagr:"25% CAGR", customer:"Farmers, FPOs, agri-input companies",       revenue:"SaaS, marketplace commission",    entry:"₹25L–₹3 Cr seed",     driver:"PM-KISAN, RKVY grants, food security demand" },
  "Logistics":         { tam:"₹6,50,000 Cr", sam:"₹1,30,000 Cr",som:"₹3,900 Cr",cagr:"14% CAGR",customer:"E-commerce companies, D2C brands, exporters",revenue:"Per-shipment fee, SaaS platform",  entry:"₹1 Cr–₹10 Cr seed",   driver:"E-commerce growth, PLI supply chain, ONDC network" },
  "D2C":               { tam:"₹3,50,000 Cr", sam:"₹1,05,000 Cr",som:"₹3,150 Cr",cagr:"38% CAGR",customer:"Urban 25–45 age group, aspirational buyers", revenue:"Direct product margin",          entry:"₹20L–₹2 Cr seed",     driver:"Social commerce, Instagram/YouTube adoption, brand consciousness" },
  "HRTech":            { tam:"₹85,000 Cr",   sam:"₹17,000 Cr", som:"₹510 Cr",   cagr:"17% CAGR", customer:"Mid-market and enterprise HR teams",        revenue:"Per-seat SaaS",                   entry:"₹25L–₹2 Cr seed",     driver:"Hybrid work, compliance requirements, talent war" },
  "GovTech":           { tam:"₹1,20,000 Cr", sam:"₹36,000 Cr", som:"₹720 Cr",   cagr:"20% CAGR", customer:"State + central govt departments",          revenue:"Govt contract / tender",          entry:"₹50L–₹5 Cr seed",     driver:"Digital India, e-governance mandates, BharatNet" },
  "CleanTech":         { tam:"₹5,00,000 Cr", sam:"₹1,00,000 Cr",som:"₹3,000 Cr",cagr:"28% CAGR", customer:"Industry, commercial buildings, households", revenue:"OPEX model, energy savings share",entry:"₹1 Cr–₹20 Cr seed",   driver:"Net-zero targets, PLI solar, EV policy push" },
  "PropTech":          { tam:"₹2,50,000 Cr", sam:"₹50,000 Cr", som:"₹1,500 Cr", cagr:"19% CAGR", customer:"Home buyers, real estate developers",       revenue:"Marketplace commission, SaaS",    entry:"₹40L–₹4 Cr seed",     driver:"Urbanisation, RERA compliance, affordable housing push" },
  /* Secondary / Manufacturing */
  "Manufacturing":     { tam:"₹22,00,000 Cr",sam:"₹4,40,000 Cr",som:"₹13,200 Cr",cagr:"12% CAGR",customer:"Distributors, OEMs, export markets",       revenue:"Product margin, licensing",       entry:"₹2 Cr–₹50 Cr seed",   driver:"PLI schemes, Make in India, China+1 strategy" },
  "EV":                { tam:"₹3,50,000 Cr", sam:"₹70,000 Cr", som:"₹2,100 Cr", cagr:"40% CAGR", customer:"Consumers, fleet operators, delivery startups",revenue:"Vehicle margin, software, battery leasing",entry:"₹2 Cr–₹50 Cr", driver:"FAME II subsidy, fuel cost savings, pollution norms" },
  "FoodTech":          { tam:"₹5,50,000 Cr", sam:"₹1,10,000 Cr",som:"₹3,300 Cr",cagr:"17% CAGR", customer:"Urban consumers, restaurants, FMCG brands", revenue:"Delivery commission, product margin",entry:"₹30L–₹5 Cr seed",   driver:"Quick commerce, food delivery normalisation, health food trend" },
  /* Primary */
  "Agriculture":       { tam:"₹31,00,000 Cr",sam:"₹6,20,000 Cr",som:"₹18,600 Cr",cagr:"6% CAGR",  customer:"Farmers, FPOs, food processors",           revenue:"Input sales, marketplace, advisory",entry:"₹15L–₹2 Cr seed (+ grants)",driver:"MSP reforms, FPO push, climate smart agriculture" },
  "Mining":            { tam:"₹4,80,000 Cr", sam:"₹96,000 Cr", som:"₹2,880 Cr", cagr:"10% CAGR",  customer:"Steel, cement, power sector companies",     revenue:"Service contract, equipment lease",entry:"₹5 Cr–₹100 Cr",       driver:"Infrastructure build-out, critical minerals demand" },
};

/* ── Sector-type fallback data ───────────────────────────────── */
const SECTOR_TYPE_FALLBACK = {
  tertiary:  { tam:"₹45,00,000 Cr+", sam:"₹9,00,000 Cr", som:"₹27,000 Cr", cagr:"18–26% CAGR", customer:"SMEs, enterprises, and digital-first consumers", revenue:"Subscription, transaction fees, SaaS", entry:"₹25L–₹5 Cr seed", driver:"Digital India, startup ecosystem, cloud infrastructure" },
  secondary: { tam:"₹32,00,000 Cr+", sam:"₹6,40,000 Cr", som:"₹19,200 Cr", cagr:"10–16% CAGR", customer:"Industrial buyers, distributors, OEMs, exporters", revenue:"Product margin, B2B contracts", entry:"₹2 Cr–₹50 Cr", driver:"PLI schemes, Make in India, global supply chain shifts" },
  primary:   { tam:"₹38,00,000 Cr+", sam:"₹7,60,000 Cr", som:"₹22,800 Cr", cagr:"5–10% CAGR",  customer:"Farmers, cooperatives, food processors, govt agencies", revenue:"Input sales, marketplace, advisory SaaS", entry:"₹15L–₹3 Cr (+ govt grants)", driver:"Rural income push, food security, AatmaNirbhar Bharat" },
};

/* ── State-adjusted SOM multiplier ──────────────────────────── */
const TIER1 = ["maharashtra","karnataka","delhi","tamil nadu","telangana","haryana","gujarat","andhra pradesh"];
const TIER2 = ["rajasthan","kerala","west bengal","madhya pradesh","uttar pradesh","punjab","odisha"];
function getStateSomNote(state) {
  if (!state) return "National reachable market from anywhere in India.";
  const s = state.toLowerCase();
  if (TIER1.some(t => s.includes(t))) return `${state} is a Tier-1 market — your SOM estimate has maximum investor visibility and customer density.`;
  if (TIER2.some(t => s.includes(t))) return `${state} is a Tier-2 market — start with state-level penetration, then expand nationally via digital channels.`;
  return `${state} is a Tier-3 market — your initial SOM will be hyperlocal; build deep penetration before geographic expansion.`;
}

/* ── Fund level → estimated SOM capture ─────────────────────── */
function getSomCapture(affordability) {
  if (!affordability) return "Bootstrap: Target ≤0.1% of SOM in Year 1 — focus on 100 paying customers first.";
  const a = affordability.toString();
  if (a.includes("100"))  return "₹100M+ capital: Target 0.5–1% of SOM in Year 1 — aggressive hiring and marketing possible.";
  if (a.includes("10-20"))return "₹10–20M capital: Target 0.2–0.5% of SOM in Year 1 — focus on repeatable sales motion.";
  if (a.includes("5-7"))  return "₹5–7M capital: Target 0.1–0.2% of SOM in Year 1 — validate one segment deeply before expanding.";
  if (a.includes("1-2"))  return "₹1–2M capital: Target 50–100 customers in Year 1 — every rupee must drive measurable revenue.";
  return "Bootstrap: Target ≤50 paying customers in Year 1 — revenue before scale.";
}

const MindMappingReportBTenthSection = ({ res, toggle }) => {
  const sectorType = (res?.sector_type ?? "tertiary").toLowerCase();
  const sector     = res?.sector ?? "";

  const mkt = useMemo(() => {
    const key = Object.keys(SECTOR_MARKET_DB).find(k =>
      sector.toLowerCase().includes(k.toLowerCase()) || k.toLowerCase().includes(sector.toLowerCase())
    );
    return key ? SECTOR_MARKET_DB[key] : (SECTOR_TYPE_FALLBACK[sectorType] ?? SECTOR_TYPE_FALLBACK.tertiary);
  }, [sector, sectorType]);

  const somNote    = useMemo(() => getStateSomNote(res?.state),           [res?.state]);
  const somCapture = useMemo(() => getSomCapture(res?.affordability),     [res?.affordability]);

  const rows = [
    {
      sno: "10 A",
      metric: "TAM — Total Addressable Market",
      indiaScale: mkt.tam,
      yourSlice: `Full India market for ${sector || (sectorType + " sector")} solutions`,
      insight: `This is the maximum market opportunity if you captured 100% share. Use this to anchor your pitch narrative — investors want to see a TAM > ₹10,000 Cr.`,
    },
    {
      sno: "",
      metric: "SAM — Serviceable Addressable Market",
      indiaScale: mkt.sam,
      yourSlice: `Realistic segment you can serve with your product scope and team size`,
      insight: `Focus your SAM on the sub-segment where your product is a 10× better solution. Investors prefer a tight SAM with high penetration over a vague large one.`,
    },
    {
      sno: "",
      metric: "SOM — Serviceable Obtainable Market",
      indiaScale: mkt.som,
      yourSlice: `Reachable in 3-5 years at seed-funded growth pace`,
      insight: somNote,
    },
    {
      sno: "",
      metric: "Year 1 Revenue Target",
      indiaScale: "₹12L–₹1.2 Cr (benchmark)",
      yourSlice: `Based on ₹${res?.affordability ?? "N/A"} initial capital`,
      insight: somCapture,
    },
    {
      sno: "",
      metric: "Market Growth Rate (CAGR)",
      indiaScale: mkt.cagr,
      yourSlice: `${sector || (sectorType + " sector")} — India growth trajectory`,
      insight: `A CAGR above 15% is investor-friendly. ${mkt.cagr.startsWith("2") || mkt.cagr.startsWith("3") || mkt.cagr.startsWith("4") ? "Your market has strong tailwinds — this is a key fundraising asset." : "Position growth as an underserved opportunity rather than a slow market."}`,
    },
    {
      sno: "",
      metric: "Primary Customer Segment",
      indiaScale: mkt.customer,
      yourSlice: `Who will pay you first in ${res?.state ?? "India"}?`,
      insight: `Your ICP (Ideal Customer Profile) should be the most desperate version of this segment — the person who will pay before you even have a product. Talk to 30 of them before building.`,
    },
    {
      sno: "",
      metric: "Dominant Revenue Model",
      indiaScale: mkt.revenue,
      yourSlice: `Proven model in your sector`,
      insight: `Start with the simplest revenue model that validates willingness-to-pay. Add complexity (subscriptions, enterprise tiers, marketplace fees) only after your first ₹10L in revenue.`,
    },
    {
      sno: "",
      metric: "Typical Seed Funding Entry",
      indiaScale: mkt.entry,
      yourSlice: `Benchmark for ${sector || sectorType} sector`,
      insight: `Match your ask to sector norms. ${mkt.entry} is the typical seed round size. Raise 18 months of runway — not more. Over-raising before traction dilutes you unnecessarily.`,
    },
    {
      sno: "",
      metric: "Key Market Growth Drivers",
      indiaScale: mkt.driver,
      yourSlice: `Macro tailwinds to reference in your pitch`,
      insight: `These drivers are your "why now" slide. Reference at least 2 of these tailwinds in your investor pitch to demonstrate market timing awareness.`,
    },
  ];

  return (
    <div className="mm-rb-tenth-container">
      <div className={toggle ? "table-adjust" : "mm-rb-tenth-final-table"}>
        <span className="mm-rb-tenth-corner mm-rb-tenth-corner-top-left" />
        <span className="mm-rb-tenth-corner mm-rb-tenth-corner-top-right" />
        <span className="mm-rb-tenth-corner mm-rb-tenth-corner-bottom-left" />
        <span className="mm-rb-tenth-corner mm-rb-tenth-corner-bottom-right" />

        <div className="mm-rb-tenth-module-title">
          <span className="module-prefix">Module 10:</span> Market Sizing &amp; Opportunity Analysis
          <span className="mm-rb-premium-tag">★ Report A+ Exclusive</span>
        </div>

        <div className="mm-rb-tenth-sub-context">
          Sector: <strong>{sector || `${sectorType.charAt(0).toUpperCase() + sectorType.slice(1)} sector`}</strong>
          {res?.state && <> · State: <strong>{res.state}</strong></>}
          {res?.affordability && <> · Initial Capital: <strong>{res.affordability}</strong></>}
        </div>

        <div className="mm-rb-tenth-table-scroll-wrapper">
          <table className="mm-rb-tenth-inner-table">
            <thead>
              <tr>
                <th className="mm-rb-tenth-col-sno">S.NO</th>
                <th>Market Dimension</th>
                <th>India Market Scale</th>
                <th>Your Segment Context</th>
                <th>Strategic Insight</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((row, i) => (
                <tr key={i}>
                  {i === 0 && (
                    <td className="mm-rb-tenth-col-sno" rowSpan={rows.length}>10 A</td>
                  )}
                  <td><strong>{row.metric}</strong></td>
                  <td className="mm-rb-tenth-scale">{row.indiaScale}</td>
                  <td className="mm-rb-tenth-user-val">{row.yourSlice}</td>
                  <td className="mm-rb-tenth-highlight">{row.insight}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default MindMappingReportBTenthSection;
